import { GoogleGenAI, createUserContent } from '@google/genai';
import { config } from '../config';
import schema from '../schema.js';
import { parse } from 'best-effort-json-parser'

const genAI = new GoogleGenAI({ apiKey: config.geminiApiKey });

// 添加全局回调函数
export const recognizeMenuFromImages = async (images, callback) => {
  try {
    // 保存回调函数到全局
    if (typeof callback === 'function') {
      recognizeMenuFromImages.callback = callback;
    }

    // 处理多张图片
    const imageParts = await Promise.all(
      images.map(async (image) => {
        const base64Data = await convertFileToBase64(image);
        return {
          inlineData: {
            data: base64Data,
            mimeType: image.type
          }
        };
      })
    );

    // 构建提示词
    const prompt = `你需要识别菜单照片，理解餐厅风格，识别图片中的全部菜品，输出菜名的对照翻译，给出一小段简短的人性化的描述。
        同时给出做法，口味，食材，加入宗教禁忌和过敏源提示。
        有同样原始名称的分类，请合并菜品。
        分类的排序按照西餐常见上菜顺序。
        如果有套餐请单独标注。
        所有的translation_price都需要将原始价格转换成目标货币。
        特别注意，如果有市价或者时价（market price），请标注在译文标题中。
        如果有规格选项，输出到dish_option。
        如果有额外添加项（例如酱汁，加肉，加料），输出到dish_addon
        目标语言是中文，目标货币是人民币,menu_currency需要根据菜单可能的语言和国家来确定。
        请严格按照schema格式输出JSON数据，确保所有必填字段都有值。
    `;

    const result = await genAI.models.generateContentStream({
      model: "gemini-2.5-flash-preview-04-17",
      contents: createUserContent([prompt, ...imageParts]),
      config: {
        responseMimeType: 'application/json',
        responseSchema: schema,
        maxOutputTokens: 65533,
        temperature: 0.85,
      }
    });

    let resultString = "";
    let lastValidJSON = null;

    for await (const chunk of result) {
      resultString += chunk.text;
      try {
        const parsedData = parse(resultString);
        if (parsedData && parsedData.menu) {
          lastValidJSON = parsedData;
          // 调用回调函数
          if (typeof callback === 'function') {
            callback(parsedData);
          }
          // 调用全局回调函数
          if (typeof recognizeMenuFromImages.callback === 'function' && recognizeMenuFromImages.callback !== callback) {
            recognizeMenuFromImages.callback(parsedData);
          }
        }
      } catch (error) {
        console.debug('Parsing intermediate chunk failed:', error);
      }
    }

    if (!lastValidJSON) {
      throw new Error('无法生成有效的菜单数据，请重试');
    }

    return lastValidJSON;
  } catch (error) {
    console.error('Error in image recognition:', error);
    throw error;
  } finally {
    // 清理全局回调函数
    delete recognizeMenuFromImages.callback;
  }
};

// 将文件转换为Base64
const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // 移除data:image/jpeg;base64,前缀
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
}; 